<template>
  <div
    v-for="comment in dataComment"
    :key="comment.id"
    class="comment-parent-container"
  >
    <div class="comment-parent-header">
      <div class="comment-header-info">
        <p v-html="comment.name" />
        <p v-html="comment.comment" />
        <p v-html="comment.created_at" />
      </div>

      <div class="comment-header-action">
        <p @click="actionHandler('reply', comment)">Reply</p>
        <p @click="actionHandler('delete', comment)">Delete</p>
      </div>

      <div v-if="activeReplyId === comment.id">
        <form @submit.prevent="actionHandler('submit-reply', comment)" >
          <textarea
            v-model="replyInput[comment.id]"
            :placeholder="'Type Your Reply'"
          />
          <button type="submit">Send</button>
        </form>
      </div>
    </div>

    <div v-if="comment.replies" class="comment-children-container">
      <SectionComboardComment
        :dataComment="comment.replies"
        :comboardId="comboardId"
        @delete-comment="emit('delete-comment',$event)"
        @reply-comment="emit('reply-comment',$event)"
      />
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import { ref, reactive, onMounted, onUnmounted, watch, watchEffect, computed, nextTick } from 'vue'
  import axios from 'axios'
  import { useToast } from 'vue-toastification'
  import dayjs from 'dayjs'
  import 'dayjs/locale/id'

  import SectionComboardComment from './SectionComboardComment.vue'

  export default {
    components: {
      SectionComboardComment
    },

    props: {
      dataComment: { type: Array, default: () => [] },
      comboardId: { type: String, default: null },
    },

    setup (props, { emit }) {
      const activeReplyId = ref(null)
      const replyInput = reactive({})
      const toast = useToast()
      const actionHandler = (type, data) => {
        if (type == 'reply') {
          activeReplyId.value = activeReplyId.value === data.id ? null : data.id
        } else if (type == 'delete') {
          emit('delete-comment', data)
        } else if (type == 'submit-reply') {
          if (!replyInput[data.id]?.trim()) return

          emit('reply-comment', { 
            parent: { 
              ...data, 
              comboard_id: data.comboard_id ?? props.comboardId 
            }, text: replyInput[data.id] 
          })

          replyInput[data.id] = ''
          activeReplyId.value = null
        }
      }

      return {
        actionHandler,
        activeReplyId,
        replyInput,
        emit,
      }
    }
  }
</script>

<style lang="scss">
  .comment-parent-container {
    width: 100%;
    height: auto;
    position: relative;

    .comment-parent-header {
      width: 90%;
      max-width: 400px;

      .comment-header-info {
        width: 100%;
        padding: 4px 12px;
        background-color: white;
        border: 1px solid lightgray;

        p {
          width: 100%;

          &:nth-child(1) {
            font-size: 14px;
            line-height: 20px;
            font-weight: 600;
          }

          &:nth-child(2) {
            font-size: 14px;
            line-height: 20px;
          }

          &:nth-child(3) {
            font-size: 12px;
            line-height: 18px;
            text-align: right;
          }
        }
      }

      .comment-header-action {
        width: 100%;
        display: flex;
        flex-direction: row;
        gap: 12px;
        justify-content: end;
        padding-right: 4px;
        margin-bottom: 16px;

        p {
          font-size: 12px;
          line-height: 18px;
          padding: 4px 12px;
          cursor: pointer;
          font-weight: 600;

          &:nth-child(2) {
            color: rgb(212, 0, 0);
          }
        }
      }
    }

    .comment-children-container {
      width: 400px;

      .comment-parent-container {
        width: calc(100% - 20px);
        margin-left: 20px;

        &::before {
          content: '';
          width: 2px;
          height: calc(100% + 16px);
          position: absolute;
          left: -10px;
          top: -42px;
          background-color: lightgray;
        }

        .comment-parent-header {
          width: 100%;
        }
      }
    }
  }
</style>
